(function () {
  function updateButton(button, checkbox) {
    if (!button || !checkbox) return;

    button.textContent = checkbox.checked ? 'Added' : 'Add to Bag';
    button.classList.toggle('is-added', checkbox.checked);
  }

  // Get summary container
  function getSummaryList() {
    return document.querySelector(
      '.bundle-summary__list[data-bundle-summary-list]'
    );
  }

  // Disable Add to Bag when all 4 slots are filled
  function updateAddToBagButtons() {
    const summaryList = getSummaryList();

    if (!summaryList) return;

    const items = summaryList.querySelectorAll(
      '.bundle-summary__items'
    );

    const filledItems = summaryList.querySelectorAll(
      '.bundle-summary__items.bundle-summary__item--filled'
    );

    const isFull = filledItems.length >= items.length;

    const buttons = document.querySelectorAll(
      '.lb-bundle-offers .custom-add-to-bag'
    );

    buttons.forEach(function (button) {
      const card = button.closest('.lb-product-card');
      const checkbox = card?.querySelector(
        '.lb-card-checkbox'
      );

      if (!checkbox) return;

      // Selected products stay enabled
      if (checkbox.checked) {
        button.disabled = false;
        return;
      }

      button.disabled = isFull;
    });
  }

  // Update summary images
  function updateBundleSummary() {
    const summaryList = getSummaryList();

    if (!summaryList) return;

    const items = Array.from(
      summaryList.querySelectorAll(
        '.bundle-summary__items'
      )
    );

    const products = Array.from(
      document.querySelectorAll(
        '.lb-bundle-offers .lb-product-card'
      )
    );

    const selectedProducts = products.filter(
      function (card) {
        const checkbox = card.querySelector(
          '.lb-card-checkbox'
        );

        return checkbox && checkbox.checked;
      }
    );

    items.forEach(function (item, index) {
      const product = selectedProducts[index];

      // Empty slot
      if (!product) {
        if (
          item.classList.contains(
            'bundle-summary__item--filled'
          )
        ) {
          item.innerHTML = '';

          item.classList.remove(
            'bundle-summary__item--filled'
          );

          delete item.dataset.productId;
        }

        return;
      }

      const image = product.querySelector(
        '.lb-card-img'
      );

      if (!image) return;

      const productId = product.getAttribute(
        'lb-product-id'
      );

      // Already showing this product
      if (
        item.dataset.productId === productId &&
        item.classList.contains(
          'bundle-summary__item--filled'
        )
      ) {
        return;
      }

      // Replace only if product changed
      item.innerHTML = '';

      const clonedImage =
        image.cloneNode(true);

      clonedImage.classList.add(
        'bundle-summary__image'
      );

      clonedImage.removeAttribute('style');

      item.appendChild(clonedImage);

      item.dataset.productId = productId;

      item.classList.add(
        'bundle-summary__item--filled'
      );
    });

    updateAddToBagButtons();
  }

  // Inject "Your Bundle" title
  function injectBundleTitle() {
    const summaryList = getSummaryList();

    if (!summaryList) return;

    // Prevent duplicate title
    if (
      summaryList.previousElementSibling?.matches(
        '.custom-bundle-title'
      )
    ) {
      return;
    }

    const title =
      document.createElement('h2');

    title.className =
      'custom-bundle-title';

    title.setAttribute(
      'data-mobile-toggle-initialized',
      'true'
    );

    title.innerHTML = `
      <span>Your Bundle</span>
      <span class="svg-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8.707"
          height="16.414"
          viewBox="0 0 8.707 16.414"
        >
          <g
            id="Icon_feather-arrow-right"
            data-name="Icon feather-arrow-right"
            transform="translate(26 23.207) rotate(180)"
          >
            <path
              id="Path_197"
              data-name="Path 197"
              d="M18,7.5,25.5,15,18,22.5"
              fill="none"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
          </g>
        </svg>
      </span>
    `;

    // Toggle summary
    title.addEventListener(
      'click',
      function () {
        const isOpen =
          summaryList.classList.toggle(
            'is-open'
          );

        title.classList.toggle(
          'visible',
          isOpen
        );
      }
    );

    // Insert title before summary
    summaryList.insertAdjacentElement(
      'beforebegin',
      title
    );
  }

  // Inject summary BEFORE CTA
  function injectBundleSummary() {
    const ctaContainers =
      document.querySelectorAll(
        '.lb-bundle-cta-cont'
      );

    ctaContainers.forEach(
      function (cta) {
        if (
          cta.previousElementSibling?.matches(
            '.bundle-summary__list'
          )
        ) {
          return;
        }

        const summaryList =
          document.createElement(
            'div'
          );

        summaryList.className =
          'bundle-summary__list';

        summaryList.setAttribute(
          'data-bundle-summary-list',
          ''
        );

        summaryList.innerHTML = `
          <div class="bundle-summary__items"></div>
          <div class="bundle-summary__items"></div>
          <div class="bundle-summary__items"></div>
          <div class="bundle-summary__items"></div>
        `;

        cta.insertAdjacentElement(
          'beforebegin',
          summaryList
        );
      }
    );

    injectBundleTitle();
    updateBundleSummary();
  }

  // Add custom Add to Bag buttons
  function addButtonsToSelleasy() {
    const products =
      document.querySelectorAll(
        '.lb-bundle-offers .lb-product-card'
      );

    products.forEach(
      function (card) {
        const price =
          card.querySelector(
            'lb-price'
          );

        const checkbox =
          card.querySelector(
            '.lb-card-checkbox'
          );

        if (!price || !checkbox)
          return;

        let button =
          card.querySelector(
            '.custom-add-to-bag'
          );

        // Create button once
        if (!button) {
          button =
            document.createElement(
              'button'
            );

          button.type = 'button';

          button.className =
            'custom-add-to-bag';

          updateButton(
            button,
            checkbox
          );

          button.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              // Prevent selecting more than 4
              if (
                !checkbox.checked &&
                document.querySelectorAll(
                  '.bundle-summary__item--filled'
                ).length >= 4
              ) {
                return;
              }

              // Immediately update button
              const newState =
                !checkbox.checked;

              button.textContent =
                newState
                  ? 'Added'
                  : 'Add to Bag';

              button.classList.toggle(
                'is-added',
                newState
              );

              // Trigger Selleasy
              checkbox.click();

              // Update summary
              setTimeout(
                function () {
                  updateBundleSummary();
                },
                0
              );
            }
          );

          // Add button below price
          price.insertAdjacentElement(
            'afterend',
            button
          );

          // Checkbox change
          checkbox.addEventListener(
            'change',
            function () {
              updateButton(
                button,
                checkbox
              );

              updateBundleSummary();
            }
          );
        } else {
          const expectedText =
            checkbox.checked
              ? 'Added'
              : 'Add to Bag';

          if (
            button.textContent !==
            expectedText
          ) {
            updateButton(
              button,
              checkbox
            );
          }
        }
      }
    );

    updateBundleSummary();
  }

  function init() {
    injectBundleSummary();
    addButtonsToSelleasy();
    updateAddToBagButtons();
  }

  // Initial
  init();

  // Watch Selleasy dynamic changes
  let observerTimeout;

  const observer =
    new MutationObserver(
      function () {
        clearTimeout(
          observerTimeout
        );

        observerTimeout =
          setTimeout(
            function () {
              init();
            },
            100
          );
      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();